import { Describe, is, string, type } from 'superstruct';

export const LoginInfoValidator: Describe<LoginInfoDto> = type({
  loginTitle: string(),
  loginText: string(),
});
export const isLoginInfo = (obj: unknown) => is(obj, LoginInfoValidator);
